module.exports = __webpack_public_path__ + "img/mg-head.39507a3f.png";